import React from "react";
import styled, { keyframes } from "styled-components";
import { connect } from "react-redux";
import Pagination from "./Pagination";
import MaskList from "./MaskList";
import NoneResultSearch from "./NoneResultSearch";
import StyleLink from "../dev/StyleLink";
import "../assets/Test.css";
import youtubeIcon from "../assets/img/yt_icon_rgb.png";
import Search from "../icon/SearchIcon";
import LocationIcon from "@material-ui/icons/LocationOn";
import RankIcon from "@material-ui/icons/BarChart";
import SubscriptionsIcon from "@material-ui/icons/Subscriptions";
import TimelineIcon from "@material-ui/icons/Timeline";
import Guide from "../dev/Guide";
import OpenInNewIcon from "@material-ui/icons/OpenInNew";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import YouTubeNumber from "../dev/validation/YouTubeNumber";
const theme = createMuiTheme({
    palette: {
        primary: { main: "#e94242" }
    },
    typography: { useNextVariants: true }
});
const comma = props => {
    if (isNaN(props)) {
        return props;
    } else {
        return Number(props).toLocaleString();
    }
};
const renderList = (
    list,
    isRate,
    isLoading,
    categoryContent,
    messages = {}
) => {
    return (
        <MuiThemeProvider theme={theme}>
            <ValuesWrap id="rankList">
                <ValuesContent isTitle>
                    <Guide list={[messages.country]}>
                        <LocationIcon />
                    </Guide>
                    {/* <div>{messages.country}</div> */}
                </ValuesContent>
                <ValuesContent isTitle>
                    <Guide list={[messages.rank]}>
                        <RankIcon />
                    </Guide>
                    {/* {messages.rank} */}
                </ValuesContent>
                <Channel isTitle />
                <ValuesContent isTitle>
                    <Guide list={[messages[categoryContent]]}>
                        <TimelineIcon />
                    </Guide>
                </ValuesContent>
                <Youtube isTitle>
                    <YoutubeIconWrap>
                        <Guide list={[messages.channel_url]}>
                            <SubscriptionsIcon />
                        </Guide>
                    </YoutubeIconWrap>
                </Youtube>
                {/* <div>{messages[categoryContent]}</div> */}
                {/* <div>{messages.channel_url}</div> */}
                {/* media query 小於 400px 時隱藏*/}
                {list.map(
                    ({
                        id,
                        channelId,
                        country,
                        avatar,
                        title,
                        rank,
                        value
                    }) => {
                        return (
                            <React.Fragment>
                                <ValuesContent>
                                    <Country isLoading={isLoading}>
                                        {country || "N/A"}
                                    </Country>
                                </ValuesContent>
                                <ValuesContent>
                                    <Rank
                                        isLoading={
                                            isLoading || rank === undefined
                                        }
                                    >
                                        {rank}
                                    </Rank>
                                </ValuesContent>
                                <Channel isLoading={isLoading}>
                                    <StyleLink
                                        to={`/Info/${id}`}
                                        target={"_blank"}
                                    >
                                        <Avatar
                                            imgUrl={avatar}
                                            isLoading={isLoading}
                                        />
                                    </StyleLink>
                                    <StyleLink
                                        to={`/Info/${id}`}
                                        target={"_blank"}
                                        hoverColor={"black"}
                                    >
                                        <ChannelTitle isLoading={isLoading}>
                                            {title}
                                        </ChannelTitle>
                                    </StyleLink>
                                </Channel>
                                <ValuesContent content="flex-end">
                                    <Category isLoading={isLoading}>
                                        {/* <MaterialButton color="primary" variant="outlined" size="small">
                                            {comma(value)}
                                            {isRate && `%`}
                                        </MaterialButton> */}
                                        {categoryContent === "subscribers"
                                            ? YouTubeNumber(value)
                                            : comma(value)}
                                        {/* 因應 yt 數據 api 更動*/}
                                        {/* {comma(value)} */}
                                        {isRate && `%`}
                                        {categoryContent === "subscribers" && (
                                            <LiveButton isLoading={isLoading}>
                                                <StyleLink
                                                    to={`/CurrentSubscriber/${id}`}
                                                    onClick={() =>
                                                        window.scrollTo(0, 0)
                                                    }
                                                    target="_blank"
                                                    width="100%"
                                                >
                                                    <Span
                                                        color="#fff"
                                                        size="12px"
                                                    >
                                                        Live
                                                        <OpenInNewIcon />
                                                    </Span>
                                                </StyleLink>
                                            </LiveButton>
                                        )}
                                    </Category>
                                </ValuesContent>
                                <Youtube>
                                    <a
                                        href={`https://www.youtube.com/channel/${channelId}`}
                                        target="_blank"
                                    >
                                        <YoutubeIconWrap isLoading={isLoading}>
                                            <img src={youtubeIcon} alt="" />
                                        </YoutubeIconWrap>
                                    </a>
                                </Youtube>
                            </React.Fragment>
                        );
                    }
                )}
            </ValuesWrap>
        </MuiThemeProvider>
    );
};
const renderNoneQuate = (categoryContent, messages, noneQuataRestart) => {
    return (
        <MuiThemeProvider>
            <ValuesWrap>
                <ValuesContent isTitle>
                    <Guide list={[messages.country]}>
                        <LocationIcon />
                    </Guide>
                    {/* <div>{messages.country}</div> */}
                </ValuesContent>
                <ValuesContent isTitle>
                    <Guide list={[messages.rank]}>
                        <RankIcon />
                    </Guide>
                    {/* {messages.rank} */}
                </ValuesContent>
                <Channel isTitle />
                <ValuesContent isTitle>
                    <Guide list={[messages[categoryContent]]}>
                        <TimelineIcon />
                    </Guide>
                </ValuesContent>
                <Youtube isTitle>
                    <YoutubeIconWrap>
                        <Guide list={[messages.channel_url]}>
                            <SubscriptionsIcon />
                        </Guide>
                    </YoutubeIconWrap>
                </Youtube>
            </ValuesWrap>
            <NoneQuataResult onClick={() => noneQuataRestart()}>
                <div>
                    {messages.ranking_youtube_quota_error}
                </div>
            </NoneQuataResult>
        </MuiThemeProvider>
    )
}
const renderMaskList = ({
    channelTitleInputValue,
    channelTitleInput,
    channelTitleSubmit,
    messages,
    plan,
    auth,
    dispatch
}) => {
    return (
        <div>
            {renderList(MaskList, false, true)}
            <Mask>
                <div>{messages.rank_want_more_01}</div>
                {auth === "notSignIn" ? (
                    <MaskLink
                        id={"ga_login_ranking"}
                        onClick={() =>
                            dispatch({
                                type: "toggleUserField",
                                condition: "signIn"
                            })
                        }
                    >
                        {messages.nav_login}
                    </MaskLink>
                ) : plan === "Free" ? (
                    <MaskLink
                        id={"ga_upgrade_ranking"}
                        onClick={() =>
                            dispatch({
                                type: "togglePaymentField",
                                isPaymentGuideActive: true,
                                paymentGuideMinPlan: "Creator"
                            })
                        }
                    >
                        {messages.rank_want_more_02}
                    </MaskLink>
                ) : (
                    ""
                )}
                <div>{messages.or}</div>
                <ChannelSearchWrap>
                    <ChannelSearchInput
                        onChange={channelTitleInput}
                        value={channelTitleInputValue}
                        onKeyPress={e =>
                            e.key === "Enter" && channelTitleSubmit()
                        }
                        type="text"
                        placeholder={messages.rank_input}
                    />
                    <ChannelSearchButton onClick={channelTitleSubmit}>
                        <Search width={15} />
                    </ChannelSearchButton>
                </ChannelSearchWrap>
            </Mask>
        </div>
    );
};
const renderLoadingList = () => {
    return <div>{renderList(MaskList, false, true)}</div>;
};
const RankList = props => {
    const {
        messages,
        title,
        channelId,
        countryName,
        resultNotFoundCountryName,
        categoryContent,
        rankList,
        url,
        isCondition,
        isLoading,
        isRate,
        resetCondition,
        countrySelect,
        togglePage,
        requestPage,
        channelIdInputValue,
        channelIdInput,
        channelIdSubmit,
        channelTitleInputValue,
        channelTitleInput,
        channelTitleSubmit,
        isIpCountryLoading,
        status,
        noneQuataRestart
    } = props;
    const { list, pageCount, isAdditionalSearchResult } = rankList[url] || {};
    const { plan, auth } = props.user;
    const { dispatch } = props;
    return (
        <Container>
            <TitleWrap>
                <Title>
                    {list !== undefined ? (
                        list.length !== 0 ? (
                            <div id={"search_term"}>
                                {isAdditionalSearchResult &&
                                    list !== undefined &&
                                    `${messages.ranking_no_result_change_to_all_01} ${resultNotFoundCountryName} ${messages.ranking_no_result_change_to_all_02}`}
                                {title !== "" &&
                                    `${title} ${messages.rank_condition_1} `}
                                {/* ex: 誰誰誰在 */}
                                {countryName === ""
                                    ? `All `
                                    : `${countryName} `}
                                {/* ex: 台灣 */}
                                {messages.rank_condition_2}
                                {/*ex: 的  */}
                                {messages[categoryContent]}
                                {/* ex: 訂閱數 */}
                                {messages.rank_condition_3} {/* ex: 排名 */}
                            </div>
                        ) : (
                            <div>
                                {messages.ranking_no_result_01}
                                {countryName === ""
                                    ? `All `
                                    : `${countryName} `}
                                {messages.ranking_no_result_02}
                                {/* ex: 找不到在 Taiwan 的結果 */}
                            </div>
                        )
                    ) : (
                        ""
                    )}
                </Title>
                <Notification>
                    {isRate && <div>{messages["rank_1000"]}</div>}
                    <div>{messages.rank_updated_daily}</div>
                    {/* ex: 數據每日更新 */}
                    {isCondition && (
                        <ResetCondition onClick={() => resetCondition()}>
                            {messages.rank_retry}
                        </ResetCondition>
                    )}
                    {/* 重試 */}
                </Notification>
            </TitleWrap>
            <React.Fragment>
                <Wrap>
                    {status === 503 ? (
                        renderNoneQuate(categoryContent, messages, noneQuataRestart)
                    ) : list === undefined ||
                      isIpCountryLoading ||
                      isLoading ? (
                        (plan === "Free" || auth === "notSignIn") &&
                        requestPage > 1 ? (
                            renderMaskList({
                                channelTitleInputValue,
                                channelTitleInput,
                                channelTitleSubmit,
                                messages,
                                plan,
                                auth,
                                dispatch
                            })
                        ) : (
                            <div>{renderLoadingList()}</div>
                        )
                    ) : (
                        [
                            plan !== "Free" &&
                                plan !== "" &&
                                renderList(
                                    list,
                                    isRate,
                                    isLoading,
                                    categoryContent,
                                    messages
                                ),
                            (plan === "Free" || auth === "notSignIn") && [
                                requestPage <= 1
                                    ? renderList(
                                          list,
                                          isRate,
                                          isLoading,
                                          categoryContent,
                                          messages
                                      )
                                    : renderMaskList({
                                          channelTitleInputValue,
                                          channelTitleInput,
                                          channelTitleSubmit,
                                          messages,
                                          plan,
                                          auth,
                                          dispatch
                                      })
                            ]
                        ]
                    )}
                </Wrap>
                {title === "" && (plan === "Free" || auth === "notSignIn") && status !== 503 && (
                    <GetMoreWrap>
                        <div>{messages.rank_want_more}</div>
                        <StyleLink
                            to={"/InfoList"}
                            onClick={() => window.scrollTo(0, 0)}
                        >
                            <GetMore>{messages.rank_more_data}</GetMore>
                        </StyleLink>
                    </GetMoreWrap>
                )}
                {(title !== "" || channelId !== "") &&
                    !isLoading &&
                    status !== 503 && (
                        <NoneResultSearch
                            resetCondition={resetCondition}
                            countrySelect={countrySelect}
                            channelIdInputValue={channelIdInputValue}
                            channelIdInput={channelIdInput}
                            channelIdSubmit={channelIdSubmit}
                        />
                    )}
            </React.Fragment>
            {!isLoading && pageCount !== 0 && status !== 503 && (
                <Pagination
                    togglePage={togglePage}
                    pageCount={pageCount}
                    requestPage={requestPage}
                    messages={messages}
                />
            )}
        </Container>
    );
};
const mapStateToProps = state => {
    return {
        user: state.User,
        messages: state.Messages
    };
};
export default connect(mapStateToProps)(RankList);

const Loading = keyframes`
    0%, 100% {
        opacity: .3;
    }
    50% {
        opacity: .1;
    }
`;
const Container = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 900px;
    margin-top: 30px;
    z-index: 1;
    @media (max-width: 900px) {
        width: calc(100% - 40px);
        /* margin: 20px 20px 0 20px; */
        margin-top: 20px;
    }
`;
const Wrap = styled.div`
    position: relative;
    width: 100%;
    margin-top: 20px;
    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.05);
`;
const TitleWrap = styled.div`
    display: flex;
    flex-direction: column;
    /* align-items: center;
    justify-content: space-between;     */
    align-items: space-between;
    justify-content: center;
    width: 100%;
    font-size: 24px;
    font-weight: 500;
    color: #787878;
    @media (max-width: 665px) {
        font-size: 18px;
    }
`;
const Title = styled.div``;
const Notification = styled.div`
    display: flex;
    align-items: center;
    margin-top: 10px;
    font-size: 12px;
    font-weight: 300;
    color: #787878;
    div:nth-child(2) {
        margin-left: 8px;
        @media (max-width: 665px) {
            margin-left: 0;
        }
    }
    @media (max-width: 665px) {
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
    }
`;
const ResetCondition = styled.div`
    display: flex;
    margin-left: 10px;
    font-size: 14px;
    font-weight: 300;
    color: #de0606;
    cursor: pointer;
    @media (max-width: 665px) {
        margin-left: 0;
    }
`;
const ValuesWrap = styled.div`
    display: grid;
    grid-template: 1fr / auto auto 1fr auto auto;
    justify-content: space-around;
    width: 100%;
    /* padding: 5px 20px; */
    background-color: ${({ isTitle }) => (isTitle ? "#de0606" : "#fff")};
    font-size: 12px;
    font-weight: 300;
    color: #fff;
    @media (max-width: 665px) {
        grid-template: 1fr / auto auto 1fr auto;
    }
`;
const ValuesContent = styled.div`
    display: flex;
    align-items: center;
    justify-content: ${({ content }) => (content ? content : "center")};
    background-color: ${({ isTitle }) => (isTitle ? "#de0606" : "#fff")};
    height: 100%;
    padding: ${({ isTitle }) => (isTitle ? "2px 10px" : "10px")};
    border-bottom: ${({ isTitle }) => (isTitle ? "" : "1px solid #e6e6e6")};
    svg {
        font-size: 20px;
    }
    @media (max-width: 665px) {
        font-size: 12px;
        padding: ${({ isTitle }) => (isTitle ? "5px" : "20px 5px")};
    }
`;
const Country = styled.div`
    display: flex;
    justify-content: center;
    min-width: 40px;
    font-size: 14px;
    font-weight: 300;
    line-height: 24px;
    color: #787878;
    ${props =>
        props.isLoading
            ? `font-size: 10px; line-height: 18px; color: transparent; background-color: #787878; border-radius: 8px; animation: ${Loading} 2s infinite;`
            : ""}
    @media (max-width: 665px) {
        min-width: 20px;
        font-size: 12px;
    }
`;
const Rank = styled.div`
    display: flex
    justify-content: center;
    min-width: 80px;
    font-size: 24px;
    font-weight: 500;
    line-height: 24px;
    color: #de0606;
    ${props =>
        props.isLoading
            ? `min-height: 1rem; font-size: 10px; line-height: 18px; color: transparent; background-color: #de0606; border-radius: 8px; animation: ${Loading} 2s infinite;`
            : ""};
    @media (max-width: 665px) {
        min-width: 30px;
        font-size: 12px;
    }
`;
const Channel = ValuesContent.extend`
    justify-content: flex-start;
    ${({ isTitle }) => (isTitle ? "justify-content: center" : "")};
    a {
        display: flex;
        align-items: center;
        height: 100%;
    }
    &:hover {
        div {
            ${({ isLoading, isTitle }) =>
                isLoading ? "" : isTitle ? "#fff" : "color: rgba(222,6,6,.8);"}
        }
    }
`;
const ChannelTitle = styled.div`
    font-size: 18px;
    font-weight: 500;
    color: #787878;
    ${props =>
        props.isLoading
            ? `font-size: 10px; color: transparent; background-color: #787878; border-radius: 8px; animation: ${Loading} 2s infinite;`
            : ""};
    @media (max-width: 665px) {
        font-size: 12px;
    }
`;
const Avatar = styled.div`
    min-width: 48px;
    min-height: 48px;
    margin-right: 20px;
    border-radius: 100%;
    background-image: url('${props => props.imgUrl}');
    background-position: center center;
    background-size: contain;
    background-repeat: no-repeat;
    ${props =>
        props.isLoading
            ? `color: transparent; background-image: none; background-color: #787878; animation: ${Loading} 2s infinite;`
            : ""}
    @media (max-width: 665px){
        min-width: 20px;
        min-height: 20px;
        margin-right: 5px;
    } 
`;
const Category = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: 40px;
    font-size: 20px;
    font-weight: 500;
    color: #787878;
    ${props =>
        props.isLoading
            ? `font-size: 10px; color: transparent; background-color: #787878; border-radius: 8px; animation: ${Loading} 2s infinite;`
            : ""};
    @media (max-width: 665px) {
        font-size: 12px;
        flex-direction: column;
    }
    a {
        display: flex;
        align-items: center;
    }
`;
const Youtube = ValuesContent.extend`
    ${({ isTitle }) => (isTitle ? "background-color: #de0606;" : "")};
    padding-left: 40px;
    a {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        corsor: pointer;
    }
    @media (max-width: 665px) {
        display: none;
        padding-left: 0;
    }
`;
const YoutubeIconWrap = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 48px;
    ${props =>
        props.isLoading
            ? `color: transparent; background-color: #de0606; border-radius: 8px; animation: ${Loading} 2s infinite;`
            : ""};
    img {
        width: 16px;
        ${props => (props.isLoading ? `display:none` : "")};
    }
    svg {
        font-size: 20px;
    }
`;
const GetMoreWrap = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
    /* justify-content: space-between; */
    /* height: 100px; */
    margin-top: 20px;
    font-size: 24px;
    font-weight: 500;
    color: #787878;
    div {
        display: flex;
        justify-content: center;
    }
    @media (max-width: 665px) {
        font-size: 18px;
    }
`;
const GetMore = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 160px;
    height: 40px;
    margin-top: 20px;
    background-color: #de0606;
    font-size: 20px;
    font-weight: 500;
    color: #fff;
    cursor: pointer;
    @media (max-width: 665px) {
        font-size: 18px;
    }
`;
const Mask = styled.div`
    position: absolute;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 900;
    background-color: rgba(255, 255, 255, 0.95);
    font-weight: 500;
    color: #787878;
    font-size: 24px;
    @media (max-width: 665px) {
        font-size: 18px;
    }
`;
const MaskLink = styled.div`
    display: flex;
    align-items: center;
    font-size: 36px;
    color: #de0606;
    text-decoration: underline;
    cursor: pointer;
    @media (max-width: 665px) {
        font-size: 20px;
    }
`;
const ChannelSearchWrap = styled.div`
    display: flex;
    margin-top: 12px;
    /* @media (max-width: 665px){
        display: none;        
    }         */
`;
const ChannelSearchInput = styled.input`
    width: 320px;
    padding-left: 6px;
    background-color: transparent;
    border: 0.5px solid #979797;
    font-size: 14px;
    line-height: 24px;
    color: #979797;
    ::-webkit-input-placeholder {
        color: #979797;
        font-weight: 300;
    }
    &:focus {
        outline: none;
    }
    @media (max-width: 665px) {
        width: 250px;
    }
`;
const ChannelSearchButton = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    background-color: #fafafa;
    border: 0.5px solid #979797;
    border-left: 0;
    @media (max-width: 665px) {
        border-left: 0.5px solid #979797;
    }
    cursor: pointer;
`;
const LiveButton = styled.div`
    display: flex;
    align-items: center;
    padding: 0 5px;
    margin: 0 0 0 10px;
    border-radius: 3px;
    height: 1rem;
    color: #fff;
    background-color: rgba(222, 6, 6, 0.8);
    /* text-decoration: underline; */
    font-size: 12px;
    cursor: pointer;
    ${({ isLoading }) => (isLoading ? "display: none" : "")};
    @media (max-width: 665px) {
        margin: 0;
        transform: scale(0.7);
    }
`;
const Span = styled.span`
    display: flex;
    align-items: center;
    color: #fff;
    font-size: 12px;
    svg {
        font-size: 12px;
        padding-left: 2px;
    }
`;
const NoneQuataResult = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px 0;
    div {
        font-size: 16px
        color: #de0606;
        text-decoration: underline;
        cursor: pointer;
    }
`


// WEBPACK FOOTER //
// ./src/Ranking/RankList.js